<template>
  

  <div class="p-4 md:p-6 shadow bg-gray2 max-w-4xl pt-4  mx-auto my-0">
            
     <p class="font-medium text-xl lg:text-2xl ">  PASO 3</p>
     <p class="font-medium text-xl lg:text-2xl text-center">  SEGURO DE AUTO</p>

     <p class="font-medium text-base  text-center pb-2"> Selecciona tu cobertura:</p>


                <div class="container w-1/2 flex gap-4 p-3">
                    <button @click="selectInsurerType('total')"  id="total"  class="container pb-4 text-lg border-b-8 gray2">Total</button>
                    <button @click="selectInsurerType('complete')"  id="complete" class="container pb-4 text-lg border-b-8 border-gray2">Complete</button>

                </div>           

                <div class="container pb-4">
                    <button @click="showCobertura()"  class="hyundai-button sm:text-base mx-auto mt-2">
                        Ver cobertura
                    </button>

                </div>
                <!-- Content goes here -->
                <div v-if="showFormSection">

                        <div v-if="showComplete" class="container md:flex md:flex-row gap-4 pt-4">
                                
                                    <button @click="selectInsurer(insurer.PRIMA_TOTAL, (insurer.PRIMA_TOTAL/months)*12, index) " :id="`insu-${index}`" 
                                        class="flex flex-col justify-center items-center  w-full md:w-56 bg-white mb-3   mx-auto shadow-xl hover:shadow-xl border-b-8 border-gray2  cursor-pointer hover:border-dark-blue insu-select"
                                        v-for="(insurer,index) in insurersComplete" :key="index">
                                                <span class=" text-lg">{{insurer.ASEGURADORA}}</span>
                                                <span class=" text-base" >${{ (insurer.PRIMA_TOTAL/months).toFixed(2) }} </span>
                                                <span class=" text-sm text-gray-700 " >MXN/MES</span>
                                    </button>
                        </div>
                        <div v-if="showTotal" class="container md:flex md:flex-row gap-4 pt-4">

                                <button @click="selectInsurer(insurer.PRIMA_TOTAL, (insurer.PRIMA_TOTAL/months)*12, index) " :id="`insu-${index}`" 
                                    class="flex flex-col justify-center items-center  w-full md:w-56 bg-white mb-3   mx-auto shadow-xl hover:shadow-xl border-b-8 border-gray2  cursor-pointer hover:border-dark-blue insu-select"
                                    v-for="(insurer,index) in insurersTotal" :key="index">
                                            <span class=" text-lg">{{insurer.ASEGURADORA}}</span>
                                            <span class=" text-base" >${{ (insurer.PRIMA_TOTAL/months).toFixed(2) }} </span>
                                            <span class=" text-sm text-gray-700 " >MXN/MES</span>
                                </button>
                     
                        </div>
       

                </div>

            <modal-form
                :show="showModal"
               @close="showModal= false"
                >
                <div>
                    <div class="p-1 bg-dark-blue text-white text-lg flex text-center">
                        <span>Cobertura {{tipoCoberturaTotal }}</span>
                    </div>
                    <div class="border border-gray2 flex ">
                        <div class="border-r border-gray3 text-center" >
                            <!-- <p class="p-4">Cobertura</p> -->
                            <p class="bg-light-brown p-2">Valor Reposición o Factura</p>
                            <p class="p-2">Daños Materiales</p>
                            <p class="bg-light-brown p-2">Robo Total</p>
                            <p class="p-2">Cristales</p>
                            <p class="bg-light-brown p-2">Robo Parcial</p>
                            <p class="p-2">RC a terceros</p>
                            <p class="bg-light-brown p-2">RC complementaria a personas</p>
                            <p class="p-2">RC en el extranjero</p>
                            <p class="bg-light-brown p-2">Gastos Legales</p>
                            <p class="p-2">Gastos Médicos Ocupantes</p>
                            <p class="bg-light-brown p-2">Gastos de transporte en Pérdida Parcial</p>
                            <p class="p-2">Gastos de transporte en Pérdida Total</p>
                            <p class="bg-light-brown p-2">Asistencia vial</p>
                            <p class="p-2">RC en extranjero</p>
                            
                        </div>
                        <div >
                            <!-- <p class="p-4 text-center">Cobertura</p> -->
                            <p class="bg-light-brown p-2 text-center">Hasta 2 años</p>
                            <p class="p-2 text-center"> 5%</p>
                            <p class="bg-light-brown p-2 text-center">10%</p>
                            <p class="p-2 text-center">20% Valor del cristal</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">$1,500,000 sin deducible</p>
                            <p class="bg-light-brown p-2 text-center">$2,500,000 sin deducible</p>
                            <p class="p-2 text-center">Amparado</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">$250,000</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">Amparado</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">Amparado</p>
                        </div>
                    </div>
                </div>
                </modal-form>

            <modal-form
                :show="showModal2"
               @close="showModal2= false"
                >
                <div>
                    <div class="p-1 bg-dark-blue text-white text-lg flex text-center">
                        <span>Cobertura {{tipoCoberturaComplete }}</span>
                     
                    </div>
                    <div class="border border-gray2 flex ">
                        <div class="border-r border-gray3 text-center" >
                            <!-- <p class="p-4">Cobertura</p> -->
                            <p class="bg-light-brown p-2">Valor Reposición o Factura</p>
                            <p class="p-2">Daños Materiales</p>
                            <p class="bg-light-brown p-2">Robo Total</p>
                            <p class="p-2">Cristales</p>
                            <p class="bg-light-brown p-2">Robo Parcial</p>
                            <p class="p-2">RC a terceros</p>
                            <p class="bg-light-brown p-2">RC complementaria a personas</p>
                            <p class="p-2">RC en el extranjero</p>
                            <p class="bg-light-brown p-2">Gastos Legales</p>
                            <p class="p-2">Gastos Médicos Ocupantes</p>
                            <p class="bg-light-brown p-2">Gastos de transporte en Pérdida Parcial</p>
                            <p class="p-2">Gastos de transporte en Pérdida Total</p>
                            <p class="bg-light-brown p-2">Asistencia vial</p>
                            <p class="p-2">RC en extranjero</p>
                        </div>
                        <div class="text-center" >
                            <!-- <p class="p-4 text-center">Cobertura</p> -->
                            <p class="bg-light-brown p-2 text-center">Hasta 2 años</p>
                            <p class="p-2 text-center"> 3%</p>
                            <p class="bg-light-brown p-2 text-center">5%</p>
                            <p class="p-2 text-center">20% Valor del cristal</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">$1,500,000 sin deducible</p>
                            <p class="bg-light-brown p-2 text-center">$2,500,000 sin deducible</p>
                            <p class="p-2 text-center">Amparado</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">$250,000</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">Amparado</p>
                            <p class="bg-light-brown p-2 text-center">Amparado</p>
                            <p class="p-2 text-center">Amparado</p>
                        </div>
                    </div>
                </div>
                </modal-form>




                <div class=" text-sm pb-2 pt-4 text-center">
                        <input v-model="showButton" type="checkbox" name="politica" id="politica">
                        Acepto los <a @click="showTerminos=true" class="cursor-pointer font-bolder underline">Términos y condiciones </a>  de arrendamiento de ABC Leasing.
                    </div> 
  
                <!-- <div v-if="showButton"  class="grid grid-cols-1  md:grid-cols-1 lg:grid-cols-3 pt-2 mt-5 gap-2"> -->
                <div v-if="showButton && showNextStep"  class="grid grid-cols-1  md:grid-cols-1  pt-2 mt-5 gap-2">
                    
   

                    <button 
                    class=" hyundai-button sm:text-base mx-auto mt-2"

                        @click="$emit('downLoadPdf')"
                    > Descarga tu tabla de pagos (Amortización)</button>
                    <!-- <button 
                    class=" hyundai-button sm:text-base mx-auto mt-2"

                        @click="$emit('showForms')"
                    > Solicita tu pre autorización de crédito digital</button> -->
                    <a 
                    class="hyundai-button-gray sm:text-base mx-auto mt-2 test"
                        target="blank"
                        :href = "`${url}/${webpage}/modelos/formulario-cotizacion/${urlQuotation}`"
                    > Solicitar cotización</a>
                    
                </div>
                <div v-else>
                    <p class="text-center text-sm">Selecciona una asegurada y acepta los términos y condiciones para continuar al siguiente paso.</p>
                </div>

                <!-- Modal de terminos y condiciones -->
                <modal-form
                :show="showTerminos"
               @close="showTerminos= false"
                >
                <p class=" font-bolder text-lg">Términos y condiciones.</p>
                <p class=" font-bolder">Por favor lea los puntos importantes sobre el uso del cotizador de FinBe ABC®</p>
                <br>    
                <p>Estimado usuario, a fin de que tenga la mejor experiencia y claridad sobre el alcance de la información que obtendrá en este cotizador, FinBe ABC® le comparte algunos puntos a considerar:</p>
                <p>•	El cotizador brinda resultados diferentes sobre las opciones de autos en arrendamiento; dependiendo del valor ingresado en cada uno de los campos del simulador (modelo, versión, plazo o anticipo) podría impactar también en el monto de rentas mostrados.
                </p>
                <p>
                •	Considere que esta información del cotizador, se calcula bajo parámetros configurados de manera predeterminada para cada plazo seleccionado. Requerir una cotización acorde a sus necesidades requiere la asistencia de un ejecutivo y podría alterar los valores, ya sea por los parámetros aplicables a los diferentes plazos, por el monto del anticipo y en general por otras variables.
                </p>
                <p>
                    •	Se le reitera que, en caso de requerir una cotización personalizada, es necesario solicitarla contactando al centro de atención a clientes. Esto le permitirá tener información concreta según sus requerimientos con un vehículo de un modelo y características muy específicas o que no se encuentre en el catálogo referenciado en el simulador.
                </p>
                <p>
                •	Para más información sobre efectividad de nuestros servicios en la deducción fiscal y los esquemas, es igualmente recomendable que nos contacte directamente, por los medios de atención a clientes.     
                </p>
                <br>    
                <p>El arrendamiento puro vehicular es un producto operado a través de ABC Leasing de México S.A.P.I. de C.V. y Bepensa Leasing S.A. de C.V., empresas que son parte de Bepensa Capital S.A. de C.V. holding de las mismas, incluida Financiera Bepensa, S.A. de C.V. SOFOM E.R. Consulte los términos y condiciones aplicables a este producto financiero, contenidas en la ficha de producto oficial de la compañía, la cual se tiene a disposición de los Ejecutivos Comerciales de la misma y de nuestra área de Atención al Cliente, la cual puede contactar al número telefónico: 5570055707</p>    
     
            </modal-form>
             
            
            </div>
</template>

<script>
import ModalForm from '../templates/ModalForm.vue'
export default {
  components: { ModalForm },

    // props:['insurers'],
    props:['insurersTotal',
        'insurersComplete',
        'months',
        'subsidiaryInfo',
        'model',
        'version',
        'modelYear',
        'isIframe',
        'downpayment',
        'monthlyPayment',
        'inteColor',
        'extColor',
        'image',
        'totalToPay',
        'financing'
    ],
    data(){
        return{
             // Variable para almacenar la url 
            url: $(".url").text(),
             // Variable para almacenar el slug del distribuidor
            webpage: ( ($(".webpage").text()) && ($(".webpage").text().length > 0  ) ) ? $(".webpage").text() : this.subsidiaryInfo ,
             // Variable para mostrar botones una vez seleccionada la aseguradora
            showButton:false,
            //Variables para colapsar componente
            showFormSection:true,
            formComplete:false,
            //variable para desplegar o contraer el div
            currentForm:true,
            //Variable para almacenar el costo total  del seguro
            primaTotal: 0,
            //Variable para asignar el costo del primer año de la aseguradora
            insurerYearCost:0,
            showComplete:false,
            showTotal:true,
            showModal:false,
            showModal2:false,
            insurerSelected:'total',
            showNextStep:false,
            showTerminos:false,
            tipoCoberturaTotal:'Total',
            tipoCoberturaComplete:'Complete',
            
            
        }
    },

    methods:{
        showSection(){
            this.showFormSection = !this.showFormSection

           
        },
        showCobertura(){
            this.insurerSelected === 'total' ? this.showModal = true : this.showModal2 = true
        },

        //Asigno el valor de la aseguradora seleccionada y le damos estilos
        selectInsurer(value, cost ,id){
            this.insurerYearCost = cost
            this.primaTotal = value
            const el = document.getElementById(`insu-${id}`) 
            var insuContainers = document.getElementsByClassName('insu-select')
            //this.showButton = true
            this.showNextStep = true
            for(var i =0; i<insuContainers.length; i++){
                if(insuContainers[i].classList.contains('border-gray2') && i === id){
                    insuContainers[i].classList.remove("border-gray2")
                    insuContainers[i].classList.add("border-dark-blue")
                }else{
                    insuContainers[i].classList.remove("border-dark-blue")
                    insuContainers[i].classList.add("border-gray2")
                }
            }

        },

        //Metodo para activar o desactivar las clases de la selección de tipos de aseguradoras
        selectInsurerType(value){
            this.insurerSelected = value
            if(value ==='total'){
                const el = document.getElementById(`total`)
                const el2 = document.getElementById(`complete`)
                el.classList.remove("border-gray2")
                el.classList.add("border-dark-blue")
                el2.classList.add("border-gray2")
                el2.classList.remove("border-dark-blue")
                this.showComplete=false
                this.showTotal=true

            }else{
                this.showTotal=false
                this.showComplete=true
                const el = document.getElementById(`complete`)
                el.classList.remove("border-gray2")
                el.classList.add("border-dark-blue")
                const el2 = document.getElementById(`total`)
                el2.classList.add("border-gray2")
                el2.classList.remove("border-dark-blue")
            }
        }
    },
    
    //Función para emitir el evento de la aseguradora seleccionada  y el costo del primer año de la aseguradora
    watch:{
        primaTotal: function (newVal) {
            this.$eventBus.$emit("insurerSelected", newVal, this.insurerYearCost);
  

        },
    },
    created(){
        console.log("Creadt",this.webpage);
        if(this.webpage && this.webpage == '' ){
            console.log('Esta vacio ')
            this.webpage = this.subsidiaryInfo
            console.log('actualizado', this.webpage)
        }
    },
    computed: {
        urlQuotation(){
            let model = this.model.replaceAll(" ", "-")
            let version = this.version.replaceAll(" ", "-")
            let fullText =  `${model.toLowerCase()}/${version.toLowerCase()}/${this.modelYear}/${this.isIframe}/1/${this.downpayment}/${parseFloat(this.monthlyPayment.replaceAll(',', ''))}/${this.months}/${this.inteColor}/${this.extColor}/${btoa(this.image)}/${this.financing}/${this.totalToPay}`
            return fullText
        },
    }

}
</script>

<style>

</style>